export function Kicker({ children }: { children: string }) {
  return (
    <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-orb-400/25 bg-orb-500/5 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.25em] text-orb-300">
      <span className="h-1 w-1 rounded-full bg-orb-300 shadow-[0_0_6px_2px_rgba(200,160,255,0.8)]" />
      {children}
    </span>
  )
}
